export const certificates = {
  title: '证书',
  resourceName: '证书',
  titles: {
    list: '证书列表',
    detail: '证书详情',
    create: '新增证书',
    edit: '编辑证书',
    addQuick: '快速新增',
  },
  sections: {
    basic: '基本信息',
    linkage: '关联企业',
    validity: '有效期与状态',
    note: '备注',
    audit: '备注与系统信息',
  },
  units: {
    days: '天',
  },
  fields: {
    code: '证书编码',
    name: '证书名称',
    certificateType: '证书类型',
    licenseNumber: '许可证号',
    expiryDate: '到期日期',
    warningDays: '预警天数',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    status: '状态',
    onOffAction: '开 / 关',
    certificateName: '证书名称',
    productCode: '关联产品',
    registeredCompany: '注册公司',
    exporterCompany: '出口公司',
    importerCompany: '进口公司',
    effectiveDate: '生效日期',
    issueDate: '签发日期',
    daysToExpire: '到期剩余时间',
    warningBeforeExpiry: '到期前60天提醒',
    note: '备注',
    actions: '操作',
  },
  filter: {
    country: '公司国家',
    allCountries: '全部',
  },
  countries: {
    VN: '越南',
    TQ: '中国',
  },
  status: {
    active: '启用',
    inactive: '停用',
    enabled: '启用',
    disabled: '停用',
  },
  validation: {
    nameRequired: '请输入证书名称',
    companyRequired: '请选择完整的三家公司',
  },
  messages: {
    importDescription: '请选择符合模板的 Excel 文件导入证书数据。',
    importSuccess: '证书导入成功',
    importFailed: '证书导入失败',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    noData: '暂无证书数据',
    totalCertificates: '总计: {total} 条证书',
    createSuccess: '创建证书成功',
    updateSuccess: '更新证书成功',
    deleteSuccess: '删除证书成功',
    confirmDelete: '确认删除该证书吗？',
  },
  import: {
    button: '导入',
    noSheet: '导入文件没有工作表',
    noData: '没有可导入的数据',
    success: '成功导入 {count} 行',
    failed: '导入失败',
  },
}
